export default date => {
  if (date) {
    const temp = new Date(date);
    return `${temp.getFullYear()}年${temp.getMonth() + 1}月${temp.getDate()}日`;
  }
  return "指定なし";
};
